import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../axiosConfig';
import { truncateEmail } from '../../Utilities/utils';
import { NOT_STARTED, ORDER_PROCESSING } from '../../Utilities/constants';
import { getEmployeeTitleRelId } from '../../Utilities/getEmployeeTitleRelId';

const UseAssignOrder = (onFetchData, onErrorAssign, onAssignOrder, modalError, downloadFile, employeeData, onUnassignOrder) => {  

  return useMutation({
    mutationFn: async ({ dataItem, field, token, accounts, employeeRole, isUnassign }) => {
      const designerType = field === 'designerChecker' ? NOT_STARTED : ORDER_PROCESSING;
      const isActive = isUnassign ? 0 : 1;  
      
      const valuesList = [{
        orderDetailId: dataItem.orderDetailId,
        employeeEmail: accounts[0].username,
        employeeTitleId: designerType,
        hoursActual: 0,
        author: truncateEmail(accounts[0].username, 50),
        isActive,  
        userRole: employeeRole,
        employeeTitleRelId: getEmployeeTitleRelId(designerType, employeeData),
      }];

      const response = await axios.post(`orderAssignation/`, valuesList, {
        headers: { Authorization: token },
      });

      return { response, dataItem, isActive };
    },
    onSuccess: ({ response, dataItem, isActive }) => {        
        if (isActive) {  
          if (response?.data?.alreadyAssignedOrders[0]) {
            downloadFile(response.data.alreadyAssignedOrders[0].imageURL);
            modalError(response.data.alreadyAssignedOrders[0].imageURL, response.data.alreadyAssignedOrders[0].errorMessage);
          } else if (response?.data?.successfullyAssignedOrders[0] === dataItem.orderDetailId) {
            onAssignOrder(); 
          }
        } else {  
            if (response?.data?.removedAssignments[0] === dataItem.orderDetailId) {
                onAssignOrder();

                onUnassignOrder();
            }
            else{
                onAssignOrder('Cannot unassign orders not assigned to you.', 'error');
                return;
            }
        }
        //this function already invalidates the current list         
        onFetchData();
        
      },
      onError: (error) => {
        onErrorAssign(error);
      },
    });
};

export default UseAssignOrder;
